export default __webpack_public_path__ + "static/media/Lang_salud-lady-working.12bc2c4e.png";